import { Route, Theme } from "@/router/router.types";
import { Layout } from "@/layouts/layouts.types";

export const userRoutes = [
  {
    path: `/${Route.AUTH}`,
    name: Route.AUTH,
    meta: {
      layout: Layout.BLANK,
      showHeader: true,
      theme: Theme.DARK,
    },
    component: () => import("@/modules/user/views/auth-view.vue"),
  },
  {
    path: `/${Route.AUTH_CONFIRM_TOKEN}/:token`,
    name: Route.AUTH_CONFIRM_TOKEN,
    meta: {
      layout: Layout.BLANK,
      showHeader: true,
      theme: Theme.DARK,
    },
    component: () => import("@/modules/user/views/auth-confirm.vue"),
  },
  {
    path: `/${Route.REGISTER}`,
    name: Route.REGISTER,
    meta: {
      layout: Layout.BLANK,
      showHeader: true,
      showBackArrow: true,
      theme: Theme.DARK,
    },
    component: () => import("@/modules/user/views/register-view.vue"),
  },
  {
    path: `/${Route.RESET}`,
    name: Route.RESET,
    meta: {
      layout: Layout.BLANK,
      showHeader: true,
      showBackArrow: true,
      theme: Theme.DARK,
    },
    component: () => import("@/modules/user/views/password-reset-view.vue"),
  },
  {
    path: `/${Route.INVITATION_CONFIRM}/:token`,
    name: Route.INVITATION_CONFIRM,
    meta: {
      layout: Layout.BLANK,
      showHeader: true,
      showBackArrow: true,
      theme: Theme.DARK,
    },
    component: () => import("@/modules/user/views/invitation-confirm.vue"),
  },
  {
    path: `/${Route.NEW_PASSWORD}/:token`,
    name: Route.NEW_PASSWORD,
    meta: {
      layout: Layout.BLANK,
      showHeader: true,
      theme: Theme.DARK,
    },
    component: () => import("@/modules/user/views/password-new-view.vue"),
  },
  {
    path: `/${Route.CONFIRM_PHONE}`,
    name: Route.CONFIRM_PHONE,
    meta: {
      layout: Layout.BLANK,
      showHeader: true,
      showBackArrow: true,
      theme: Theme.DARK,
    },
    component: () => import("@/modules/user/views/confirm-phone-view.vue"),
  },
];
